export default "__VITE_ASSET__CrlVNRyu__"